import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { BotMessageSquare } from "lucide-react"
import backgroundImage from "@/images/bg.webp"

type LandingPageProps = {
  organizationName: string
  children: ReactNode
}

export const LandingPage = ({ organizationName, children }: LandingPageProps) => {
  const { t } = useTranslation()

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <div className="flex items-center gap-2 font-medium">
            <div className="bg-primary text-primary-foreground flex size-6 items-center justify-center rounded-md">
              <BotMessageSquare className="size-4" />
            </div>
            {organizationName}
          </div>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">{children}</div>
        </div>
      </div>
      <div className="bg-muted relative hidden lg:block">
        <img
          src={backgroundImage}
          alt={t("landing.login.background_alt")}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    </div>
  )
}
